import {IconAsset, SvgType} from '@sail/icons/types';
import {createView} from '@sail/ui';
import type {View} from '@sail/engine';

// TODO: move this into @sail/icons/react/BrandIcon
const PhantomIconSVG = createView((props: View.IntrinsicElement<'svg'>) => {
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#AB9FF2" />
      <path
        d="M9.00851 32C12.6864 32 15.4503 28.8015 17.0998 26.274C16.8992 26.8332 16.7877 27.3923 16.7877 27.9292C16.7877 29.4054 17.6348 30.4566 19.3065 30.4566C21.6023 30.4566 24.0542 28.4436 25.3248 26.274C25.2356 26.5871 25.1911 26.8779 25.1911 27.1463C25.1911 28.1752 25.7706 28.8239 26.952 28.8239C30.6744 28.8239 34.4191 22.2255 34.4191 16.4548C34.4191 11.959 32.1455 8 26.4393 8C16.4088 8 5.59814 20.2572 5.59814 28.1752C5.59814 31.2842 7.26989 32 9.00851 32ZM22.9843 15.9627C22.9843 14.8444 23.6085 14.0615 24.5223 14.0615C25.4139 14.0615 26.0381 14.8444 26.0381 15.9627C26.0381 17.0811 25.4139 17.8863 24.5223 17.8863C23.6085 17.8863 22.9843 17.0811 22.9843 15.9627ZM27.7544 15.9627C27.7544 14.8444 28.3785 14.0615 29.2924 14.0615C30.184 14.0615 30.8081 14.8444 30.8081 15.9627C30.8081 17.0811 30.184 17.8863 29.2924 17.8863C28.3785 17.8863 27.7544 17.0811 27.7544 15.9627Z"
        fill="#FFFDF8"
      />
    </svg>
  );
});

// eslint-disable-next-line @stripe-internal/stripe/no-mixed-react-exports
export const phantom: IconAsset = {
  category: 'icon',
  colorable: true,
  name: 'PhantomIconSVG',
  svg: PhantomIconSVG as SvgType,
};
